export default function DrawdownCardMock() {
  // SVG underwater curve
  const width = 260;
  const height = 60;
  const points = [
    [0, 0], [15, -5], [30, -18], [50, -26], [70, -22], [90, -10],
    [110, -3], [125, 0], [140, -8], [160, -15], [175, -12],
    [195, -6], [210, -2], [225, 0], [240, -4], [260, -7],
  ];
  const path = points
    .map(([x, y], i) => `${i === 0 ? 'M' : 'L'}${x},${height + y}`)
    .join(' ');
  const areaPath = path + ` L${width},${height} L0,${height} Z`;

  return (
    <div className="platform-mock mock-sidebar">
      <div className="platform-mock-header"><span className="dot" style={{ background: '#ef4444' }} /> Drawdown</div>
      <div className="platform-mock-body" style={{ padding: '1rem 1.25rem' }}>
        {/* Underwater chart */}
        <svg viewBox={`0 0 ${width} ${height}`} style={{ width: '100%', height: 60, marginBottom: '0.5rem' }}>
          <defs>
            <linearGradient id="dd-grad" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#ef4444" stopOpacity="0.35" />
              <stop offset="100%" stopColor="#ef4444" stopOpacity="0.05" />
            </linearGradient>
          </defs>
          <line x1="0" y1={height} x2={width} y2={height} stroke="#1f2937" strokeWidth="1" />
          <path d={areaPath} fill="url(#dd-grad)" />
          <path d={path} fill="none" stroke="#ef4444" strokeWidth="1.5" />
        </svg>

        {/* Key metrics */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.5rem 1rem' }}>
          <div>
            <div style={{ fontSize: '0.5625rem', color: '#6b7280', textTransform: 'uppercase', fontWeight: 700, letterSpacing: '0.05em' }}>
              Max Depth
            </div>
            <div style={{ fontSize: '1rem', fontWeight: 700, color: '#ef4444' }}>-26.4%</div>
          </div>
          <div>
            <div style={{ fontSize: '0.5625rem', color: '#6b7280', textTransform: 'uppercase', fontWeight: 700, letterSpacing: '0.05em' }}>
              Recovery Factor
            </div>
            <div style={{ fontSize: '1rem', fontWeight: 700, color: '#e5e7eb' }}>2.9x</div>
          </div>
          <div>
            <div style={{ fontSize: '0.5625rem', color: '#6b7280', textTransform: 'uppercase', fontWeight: 700, letterSpacing: '0.05em' }}>
              Longest
            </div>
            <div style={{ fontSize: '0.8125rem', fontWeight: 600, color: '#9ca3af' }}>1268d</div>
          </div>
          <div>
            <div style={{ fontSize: '0.5625rem', color: '#6b7280', textTransform: 'uppercase', fontWeight: 700, letterSpacing: '0.05em' }}>
              Median Recovery
            </div>
            <div style={{ fontSize: '0.8125rem', fontWeight: 600, color: '#9ca3af' }}>18d</div>
          </div>
        </div>
      </div>
      <div className="platform-mock-caption">
        Drawdown shows how deep the strategy fell from its peaks and how long it took to recover.
      </div>
    </div>
  );
}
